import { ITitleTextCenteredColoredCard } from './types';
import { RichText } from 'prismic-reactjs';
import CustomPrismicLink from '@components/CustomPrismicLink';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapTitleTextCenteredColoredCard } from './mapTitleTextCenteredColoredCard';

const TitleTextCenteredColoredCard: React.FC<ITitleTextCenteredColoredCard> = ({
  backgroundColor,
  text,
  title,
}) => {
  return (
    <>
      <section className="root">
        <RichText render={title} />
        <RichText render={text} serializeHyperlink={CustomPrismicLink} />
      </section>
      <style jsx>{`
        .giftitem {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .img {
          width: 60px;
        }

        .root {
          background-color: ${backgroundColor};
          padding: var(--space-5);
        }

        .root :global(h1) {
          text-align: center;
          margin-bottom: var(--space-6);
        }

        .root :global(p) {
          font-weight: var(--font-weight-bold);
        }

        .root :global(p):not(:last-child) {
          padding-bottom: var(----space-3);
        }

        .root :global(a) {
          color: var(--clr-secondary-1);
        }
      `}</style>
    </>
  );
};

export default withSlice(
  TitleTextCenteredColoredCard,
  mapTitleTextCenteredColoredCard,
);
